module.exports = "pegasus_template/assets/blocks/header-8-theme3.png";